var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#FDF4F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4114 5.85358C10.3839 5.6539 10.2102 5.5 10.0001 5.5C9.77077 5.5 9.5849 5.68316 9.5849 5.90909V13.1L6.95933 10.5023L6.91285 10.4626C6.75057 10.3435 6.5199 10.3562 6.37221 10.5011C6.20974 10.6606 6.2092 10.9196 6.37099 11.0797L9.7002 14.3738C9.71928 14.3935 9.74032 14.4112 9.76302 14.4268C9.92515 14.5383 10.15 14.5226 10.2945 14.3797L13.629 11.0797L13.6691 11.0337C13.7894 10.8733 13.7755 10.646 13.6278 10.5011C13.4653 10.3417 13.2024 10.3423 13.0406 10.5024L10.4152 13.1006V5.90909L10.4114 5.85358Z",
    fill: "#D92C3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownIcon);
export default __webpack_public_path__ + "static/media/down_icon.8460da54b3f228db0d2437740749ea30.svg";
export { ForwardRef as ReactComponent };